import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { TravelReimbursementModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-data.model';
import { TravelDetailListingModel } from 'common/models/page-models/travel-reimbursement/travel-detail-model';
import { TravelReimbursementDetailDataService } from 'common/services/data-services/admin/travel-reimbursement/travel-detail-data.service';
import { TravelDetailGridMetaModel } from 'common/models/page-models/travel-reimbursement/travel-detail-grid-meta-model';
import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { API_URL } from 'common/constants/sm-constants';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver';


@Injectable({
    providedIn: 'root'
})
export class TravelDetailGridWidgetService extends GridWidgetService<TravelReimbursementModel, TravelDetailListingModel> {
    constructor(protected override ds: TravelReimbursementDetailDataService, protected systemService: SystemService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new TravelDetailGridMetaModel().getMetaModel();
        return meta;
    }

    override prepareMetaModel(dataModel: DataModel, metaModel: TravelDetailGridMetaModel, routeData: WidgetModel): Promise<TravelDetailGridMetaModel> {
        return new Promise<TravelDetailGridMetaModel>((resolve, reject) => {
          //  console.log(routeData);
            resolve(metaModel);
        });
    }

    // downloadZip(payload) {
    //     this.ds.downloadToBlob(environment.apiUrl + API_URL.travelReimbursementDocDownload, payload).then((data) => {
    //         this.systemService.showSuccess(data['header'].msg)
    //     })
    // }

    downloadZip(payload: any): void {
        const apiUrl = environment.apiUrl + API_URL.travelReimbursementDocDownload;
    
        this.ds.downloadToBlob(apiUrl, payload).then(
          (data) => {
            const blob = new Blob([data], { type: 'application/zip' }); // Specify the MIME type
            const filename = 'download.zip'; // Default filename or derive from response
            saveAs(blob, filename); // Save the file using file-saver
            this.systemService.showSuccess('File downloaded successfully');
          },
          (error) => {
            console.error('Error while downloading file:', error);
            this.systemService.showError('Error downloading file');
          }
        );
      }

}